<div class="body">
    <div class="spacer"></div>
    <div class="content">
        <div class="canvas-wrapper" [style.width.px]="width" [style.height.px]="height">
            <div class="spacer"></div>
            <canvas #canvas class="draw-canvas" [class.drawable]="drawable" [class.not-drawable]="!drawable"></canvas>
            <div class="spacer"></div>
        </div>
        <div class="footer-control">
            <mat-icon class="control-icon clear" (click)="clearSignature()" #clear>delete_forever</mat-icon>
            <mat-icon class="control-icon resize" (click)="resizeImage()" *ngIf="!resized">photo_size_select_large</mat-icon>
            <mat-icon class="control-icon save" (click)="saveSignature()" *ngIf="resized">done</mat-icon>
        </div>
    </div>
    <div class="spacer"></div>
</div>
<a #link style="display: none;"></a>